import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextDate from '../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';
import TextRegno from 'components/text/TextRegno';



export const HeimavellirClaimList = ({list, isClaimNumber = false})  => {

    if (!list){
        return null;
    }    


  return (                 
        <div>
            <span>Fjöldi færslna í lista {list.length}</span>
            <div className="table-wrap">
                <table className="table advanced hover ">
                    <colgroup>
                        {isClaimNumber && <col width="120px"/>}                        
                        <col width="18%" />
                        <col />
                        <col width="120px" />
                        <col width="120px"/>
                        <col width="120px"/>
                        <col width="120px"/>
                    </colgroup>
                    <thead>
                        <tr>                            
                            {isClaimNumber && <th className="no-right-border">Kröfunúmer</th>}
                            <th className="no-right-border">Kröfuhafi</th>
                            <th className="no-right-border no-left-border">Skuldari</th>
                            <th className="no-right-border no-left-border">Tilvísun</th>
                            <th className="no-right-border no-left-border">Gjalddagi</th>
                            <th className="no-right-border no-left-border">Eindagi</th>
                            <th className="no-right-border no-left-border">Upphæð</th>
                        </tr>
                    </thead>
                    <tbody>
                    {list.map((claim, index) =>                                                     
                        <React.Fragment key={index + '_frag'}>
                        <tr key={index} className="ci-animate-repeat">                        
                            {isClaimNumber && <th className="no-right-border">{claim.claimNumber}</th>}                                
                            <td className="no-left-border ">                                
                                <TextRegno value={claim.creditor.regno}/> &nbsp; {claim.creditor.name} &nbsp; </td>
                            <td className="no-left-border">
                                {claim.debtors.map((debtor, dindex) => 
                                            <div key={dindex}>
                                                <TextRegno value={debtor.regno}/> &nbsp; {debtor.name} &nbsp; 
                                                <span className="tag tag-debtor-type-{{debtor.debtorTypeID}}">{debtor.debtorTypeName}</span> <br/>                                                                                    
                                            </div>)
                                    }                                                                      
                            </td>
                            <td className="no-left-border ">{claim.referenceNumber }</td>
                            <td className="no-left-border "><TextDate value={claim.dueDate }/></td>
                            <td className="no-left-border "><TextDate value={claim.finalDueDate }/></td>
                            <td className="no-left-border text-right"><TextAmount value={claim.amount}/></td>
                        </tr>
                        {claim.isError && (
                            <tr key={index + '_error'} className="ci-animate-repeat">
                                <td colspan="6">
                                    Villa í innlestrarlínu. {claim.errorLine}
                                </td>
                            </tr>
                            )}                                            
                        </React.Fragment>)}                        
                    </tbody>
                </table>
            </div>
        </div>         
    
  );
};

HeimavellirClaimList.propTypes = {
    list: PropTypes.array,  
};